export const title = 'Configuración de canopy';
export const notFound = 'No se encontró la actividad de canopy.';

export const dailyLimit = 'Límite diario de tickets de canopy';
export const dailyLimitHint = 'Con 0 no se venden tickets de canopy.';
export const dailyLimitButton = 'Editar límite diario';
export const dailyLimitUpdated = 'Límite diario actualizado';
export const dailyLimitError = 'Error al actualizar el límite diario';
export const price = 'Precio del ticket de canopy';
export const priceHint = 'Se sincroniza con Relbase.';
export const priceButton = 'Editar precio';
export const priceUpdated = 'Precio actualizado';
export const priceError = 'Error al actualizar el precio';
export const requiredField = 'Campo requerido';

export const availabilityTitle = 'Disponibilidad de canopy';
export const seasonTitle = 'Aplicar temporada';
export const seasonRange = 'Rango de fechas';
export const seasonWeekdays = 'Días de la semana';
export const seasonWeekdaysHint = 'Sin días seleccionados se aplica a todos los días.';
export const seasonAction = 'Acción';
export const open = 'Abrir';
export const close = 'Cerrar';
export const seasonButton = 'Aplicar';
export const weekdays = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

export const hintOpenDays =
  'Solo se modifican los días en que el parque ya está abierto. Si abres nuevos días en Disponibilidad, vuelve a aplicar la temporada.';
export const hintSoldTickets = 'Cerrar un día no anula los tickets ya vendidos.';

export const statusOpen = 'Abierto';
export const statusClosed = 'Cerrado';
export const statusParkClosed = 'Parque cerrado';
export const parkClosedDay =
  'El parque está cerrado ese día. Ábrelo primero en Disponibilidad.';

export const availabilityUpdated = 'Disponibilidad actualizada';
export const availabilityError = 'Error al actualizar la disponibilidad';

export const confirmSeason = (
  isOpen: boolean,
  startDate: string,
  endDate: string
): string =>
  `¿Seguro que quieres ${
    isOpen ? 'abrir' : 'cerrar'
  } canopy entre el ${startDate} y el ${endDate}?`;
export const confirmDay = (isOpen: boolean, day: string): string =>
  `¿Seguro que quieres ${isOpen ? 'abrir' : 'cerrar'} canopy el ${day}?`;
